import gql from "graphql-tag";
import LockablePostFields from "../../fragments/engagement/LockablePostFields";

export default gql`
  mutation LockPost($postId: ObjectID!) {
    lockPost(postId: $postId) {
      ...LockablePostFields
    }
  }

  ${LockablePostFields}
`;
